module.exports = __webpack_public_path__ + "img/visuels-campagne-summerdays-22_slideshow.c0015d26.png";